import { DisplayBanner } from "../../banner/bannerSlice";

export const createTeamAccepted = (
  teamName: string | undefined
): DisplayBanner => ({
  type: "success",
  header: "The team has been created successfully",
  content: `The team ${teamName} has been created. This change may take a while to be reflected in Crew and Roster 2.0.`,
  dissmissible: true,
});

export const createTeamSuccess = (
  teamName: string | undefined
): DisplayBanner => ({
  type: "success",
  content: `The team ${teamName} has been created successfully.`,
  dissmissible: true,
});
